import { html, TemplateResult } from "lit/html.js";
import { ButtonComponent } from "@components/common";


const LocationPreferenceTemplate = (messages: IMessages, { handleWhereInput, handleLocationPreferenceSave, handleLocationPreferenceSkip }: IProposalModel): TemplateResult => {
  return html`
  <div class="modal-body">
    <div class="proposal-claim">
      <div class="description-wrapper">
        <p class="description">${messages.ProposalNewPopupLocationExplicitly}</p>
      </div>
    </div>
    <form
      class="my-searches-form"
      name="forms.my-searches"
      @submit=${handleLocationPreferenceSave}
      novalidate
    >
      <div class="proposal-form__field">
        <location-typeahead-component
        labelText=${messages.SubscriptionNewPopupLocationText}
        placeholder=${messages.SubscriptionNewEnterLocationField}
        @location-change-event=${handleWhereInput}
        >
        </location-typeahead-component>
      </div>
      <div class="my-searches-form__button-container">
        <a class="jr-button jr-button-material jr-button-material--textual" @click=${handleLocationPreferenceSkip}>${messages.SubscriptionNewSkipPopup}</a>
        ${ButtonComponent({ type: 'submit', cssClasses: 'jr-button jr-button-material', btnText: messages.SubscriptionNewActivatePopup })}
      </div>
    </form>
  </div>`;
}

export default LocationPreferenceTemplate;